import { Dayjs } from 'dayjs';
import { commonTexts, journalTexts } from 'consts/text';
import { SelectOptionType } from 'types';
import { useIsMobile } from 'hooks/useIsMobile/useIsMobile';
import {
    DatePickerArrowButtonType,
    DatePickerWithArrows,
} from 'components/molecules/DatePickerWithArrows/DatePickerWithArrows';
import { customWeekStartEndFormat } from 'utils/customWeekStartEndFormat';
import { DateRangeFilterType } from 'hooks/useDateRangeFilterType/useDateRangeFilterType';
import { Container, StyledSelect } from './JournalTopicsFilters.styled';

const topicsDateRangeTypeOptions: SelectOptionType<DateRangeFilterType>[] = [
    {
        label: journalTexts.journalDetails.groupJournal.schedules.daily,
        value: 'DAILY',
    },
    {
        label: journalTexts.journalDetails.groupJournal.schedules.weekly,
        value: 'WEEKLY',
    },
];

type JournalTopicsFiltersProps = {
    date: Dayjs;
    dateRangeFilterType: DateRangeFilterType;
    onDateChange: (newDate: Dayjs | null) => void;
    onDateRangeFilterTypeChange: (dateRangeFilterType: DateRangeFilterType) => void;
    onClickNextOrPrevDate: (arrowButtonType: DatePickerArrowButtonType) => void;
};

export const JournalTopicsFilters = ({
    date,
    dateRangeFilterType,
    onDateChange,
    onDateRangeFilterTypeChange,
    onClickNextOrPrevDate,
}: JournalTopicsFiltersProps) => {
    const isMobile = useIsMobile();
    const isWeeklyRange = dateRangeFilterType === 'WEEKLY';

    return (
        <Container>
            <DatePickerWithArrows
                picker={isWeeklyRange ? 'week' : 'date'}
                format={isWeeklyRange ? customWeekStartEndFormat : undefined}
                value={date}
                onChange={onDateChange}
                onArrowButtonClick={onClickNextOrPrevDate}
            />
            <StyledSelect
                label={commonTexts.actionLabels.selectRange}
                value={dateRangeFilterType}
                options={topicsDateRangeTypeOptions}
                onChange={onDateRangeFilterTypeChange}
                allowClear={false}
                showSearch={false}
                isFitContentWidth={!isMobile}
            />
        </Container>
    );
};
